import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** SSOのプロトコル */
enum SsoProtocol {
  saml = 'SAML',
  oidc = 'OIDC',
}

const nameConfig = {
  saml: new Map([
    [Locale.ja, 'SAML'],
    [Locale.en, 'SAML'],
  ]),
  oidc: new Map([
    [Locale.ja, 'OIDC'],
    [Locale.en, 'OIDC'],
  ]),
};

const toEnum = rawValueToEnum(SsoProtocol, SsoProtocol.saml);
const toDisplay = enumToName(SsoProtocol, nameConfig);
const toDisplayWithPrefix = enumToName(SsoProtocol, nameConfig, { prefix: true });

export const ssoProtocol = {
  enum: SsoProtocol,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SsoProtocol };
